import NotFoundContent from '../components/NotFoundContent/NotFoundContent';

const NotFound = () => {
  return <NotFoundContent />;
};

export default NotFound;
